// LogoutPopup.jsx

import { useNavigate } from "react-router-dom";
import "./LogoutPopup.css";

const LogoutPopup = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate(-1);
  };

  const handleLogout = () => {
    navigate("/");
  };

  return (
    <div className="logoutpopup-overlay">
      <div className="logoutpopup-modal">
        <span className="logoutpopup-close" onClick={handleClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M15 5L5 15"
              stroke="#3E3E3E"
              stroke-width="1.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5 5L15 15"
              stroke="#3E3E3E"
              stroke-width="1.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>

        <div className="logoutpopup-icon-box">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
          >
            <path
              d="M12 28H6.66667C5.95942 28 5.28115 27.719 4.78105 27.219C4.28095 26.7189 4 26.0406 4 25.3333V6.66667C4 5.95942 4.28095 5.28115 4.78105 4.78105C5.28115 4.28095 5.95942 4 6.66667 4H12"
              stroke="#E7000B"
              stroke-width="2.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M21.3335 22.6663L28.0002 15.9997L21.3335 9.33301"
              stroke="#E7000B"
              stroke-width="2.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M28 16H12"
              stroke="#E7000B"
              stroke-width="2.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <h2>Logout Confirmation</h2>
        <p>Are you sure you want to logout from your account?</p>

        <div className="logoutpopup-info">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M12.6668 14V12.6667C12.6668 11.9594 12.3859 11.2811 11.8858 10.781C11.3857 10.281 10.7074 10 10.0002 10H6.00016C5.29292 10 4.61464 10.281 4.11454 10.781C3.61445 11.2811 3.3335 11.9594 3.3335 12.6667V14"
                stroke="#9E9E9E"
                stroke-width="1.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.00016 7.33333C9.47292 7.33333 10.6668 6.13943 10.6668 4.66667C10.6668 3.19391 9.47292 2 8.00016 2C6.5274 2 5.3335 3.19391 5.3335 4.66667C5.3335 6.13943 6.5274 7.33333 8.00016 7.33333Z"
                stroke="#9E9E9E"
                stroke-width="1.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <strong> Admin:</strong> Prachi Kunjir
          </div>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
            >
              <path
                d="M0.840684 9.55099C0.753593 9.64645 0.696119 9.76515 0.675254 9.89267C0.654388 10.0202 0.67103 10.151 0.723154 10.2693C0.775279 10.3875 0.86064 10.488 0.968854 10.5586C1.07707 10.6293 1.20347 10.6669 1.33268 10.667H11.9994C12.1285 10.667 12.255 10.6295 12.3633 10.5591C12.4715 10.4886 12.557 10.3882 12.6093 10.27C12.6615 10.1518 12.6783 10.021 12.6576 9.89352C12.6369 9.76599 12.5796 9.64722 12.4927 9.55166C11.606 8.63766 10.666 7.66633 10.666 4.66699C10.666 3.60613 10.2446 2.58871 9.49444 1.83857C8.7443 1.08842 7.72688 0.666992 6.66602 0.666992C5.60515 0.666992 4.58774 1.08842 3.83759 1.83857C3.08744 2.58871 2.66602 3.60613 2.66602 4.66699C2.66602 7.66633 1.72535 8.63766 0.840684 9.55099Z"
                stroke="#9E9E9E"
                stroke-width="1.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>{" "}
            <strong>Session Time:</strong> 12:37:06
          </div>
        </div>

        <div className="logoutpopup-actions">
          <button className="logoutpopup-cancel-btn" onClick={handleClose}>
            Cancel
          </button>

          <button className="logoutpopup-confirm-btn" onClick={handleLogout}>
            Confirm Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutPopup;
